import { useEffect } from 'react';

export function usePageMeta(title, description, canonicalUrl, ogImage) {
  useEffect(() => {
    document.title = title;

    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', description);
    }

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = canonicalUrl || window.location.href;

    if (ogImage) {
      let ogImageMeta = document.querySelector('meta[property="og:image"]');
      if (!ogImageMeta) {
        ogImageMeta = document.createElement('meta');
        ogImageMeta.setAttribute('property', 'og:image');
        document.head.appendChild(ogImageMeta);
      }
      const fullImageUrl = ogImage.startsWith('http') ? ogImage : `https://kodefactor.io${ogImage}`;
      ogImageMeta.setAttribute('content', fullImageUrl);
    }

    window.scrollTo(0, 0);
  }, [title, description, canonicalUrl, ogImage]);
}
